import {
    AccountUserLimitModelDto as BoAccountUserLimitDto,
    GetUserProductLimitsResponseModelDto as BoCompanyUserProductLimitDto,
} from '@treasury/api/bo';
import {
    AccountUserLimitModelDto as ConsumerAccountUserLimitDto,
    GetUserProductLimitsResponseModelDto as ConsumerCompanyUserProductLimitDto,
} from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { CompanyUserAccountLimit } from './company-user-account-limit.entity';

const defaultUserProductLimits: BoCompanyUserProductLimitDto = {
    productType: '',
    userProductLimit: {
        initiationLimit: 0,
        approvalLimit: 0,
    },
    pendingUserProductLimit: {
        initiationLimit: 0,
        approvalLimit: 0,
    },
    userAccountLimits: [],
    productDailyLimit: 0,
};

export class CompanyUserProductLimits extends DomainEntity<
    BoCompanyUserProductLimitDto | ConsumerCompanyUserProductLimitDto
> {
    constructor(dto: BoCompanyUserProductLimitDto | ConsumerCompanyUserProductLimitDto) {
        super(dto);
        this.userAccountLimits = dto.userAccountLimits?.map(
            limit =>
                new CompanyUserAccountLimit(
                    limit as BoAccountUserLimitDto | ConsumerAccountUserLimitDto
                )
        );
    }

    public userAccountLimits?: CompanyUserAccountLimit[];

    public override toDto() {
        if (this.userAccountLimits) {
            this.dto.userAccountLimits = this.userAccountLimits.map(limit => limit.toDto());
        }
        return this.dto;
    }

    public get productType() {
        return this.dto.productType;
    }

    public set productType(value: string | undefined) {
        this.dto.productType = value;
    }

    public get productInitiationLimit() {
        return this.dto.userProductLimit?.initiationLimit;
    }

    public get productApprovalLimit() {
        return this.dto.userProductLimit?.approvalLimit;
    }

    public get pendingProductInitiationLimit() {
        return this.dto.pendingUserProductLimit?.initiationLimit;
    }

    public set pendingProductInitiationLimit(value: number | undefined) {
        if (!this.dto.pendingUserProductLimit) {
            this.dto.pendingUserProductLimit = {};
        }
        this.dto.pendingUserProductLimit.initiationLimit = value;
    }

    public get pendingProductApprovalLimit() {
        return this.dto.pendingUserProductLimit?.approvalLimit;
    }

    public set pendingProductApprovalLimit(value: number | undefined) {
        if (!this.dto.pendingUserProductLimit) {
            this.dto.pendingUserProductLimit = {};
        }
        this.dto.pendingUserProductLimit.approvalLimit = value;
    }

    public get productDailyLimit() {
        return this.dto.productDailyLimit;
    }

    public createDefault(): this {
        return new CompanyUserProductLimits(defaultUserProductLimits) as this;
    }
}
